var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 65,
    viewBox: "0 0 29 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 62.499H26.5L22.314 49.1129L14.9165 29.499L2.5 62.499Z",
    fill: "#D6AF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9165 29.499V17.499M14.9165 29.499L2.5 62.499H26.5L22.314 49.1129L14.9165 29.499ZM5.81135 34.1865L8.36047 29.499L14.9165 17.499L21.7558 30.0307L23.9884 34.1865",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.49963C10.5 7.56049 10.9214 8.57791 11.6716 9.32805C12.4217 10.0782 13.4391 10.4996 14.5 10.4996C15.5609 10.4996 16.5783 10.0782 17.3284 9.32805C18.0786 8.57791 18.5 7.56049 18.5 6.49963C18.5 5.43876 18.0786 4.42135 17.3284 3.6712C16.5783 2.92105 15.5609 2.49963 14.5 2.49963C13.4391 2.49963 12.4217 2.92105 11.6716 3.6712C10.9214 4.42135 10.5 5.43876 10.5 6.49963Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup81);
export default __webpack_public_path__ + "static/media/Group 81.711f10802c1977943661eac29b70ab29.svg";
export { ForwardRef as ReactComponent };